import React from 'react';

// ---------------------------------------------------------------------------
// AuthBackdrop: the sign-in pages' ambient layer, behind AuthShell's column.
// A warm copper halo low in the middle, a cool blue glow from the top, a
// vignette top and bottom, and a faint film grain. All colours come from the
// theme (the shell sets the dark scope): copper is --attention, blue is
// --primary.
// ---------------------------------------------------------------------------

// Grain: an SVG fractalNoise tile as a data URI, blended over the glow.
const GRAIN_SVG =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'>` +
      `<filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/></filter>` +
      `<rect width='100%' height='100%' filter='url(#n)' opacity='1'/>` +
      `</svg>`,
  );

export function AuthBackdrop() {
  return (
    <>
      <div aria-hidden className="pointer-events-none absolute inset-0 z-0">
        <div
          className="absolute bottom-[-24%] left-1/2 h-[78vh] w-[120vw] -translate-x-1/2 rounded-full blur-[14px]"
          style={{ background: 'radial-gradient(ellipse at center, hsl(var(--attention) / 0.14) 0%, transparent 62%)' }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(120% 90% at 50% -10%, hsl(var(--primary) / 0.05), transparent 55%), linear-gradient(180deg, rgba(0,0,0,0.28), transparent 32%, transparent 68%, rgba(0,0,0,0.45))',
          }}
        />
      </div>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-[1]"
        style={{
          backgroundImage: `url("${GRAIN_SVG}")`,
          backgroundSize: '160px 160px',
          opacity: 0.04,
          mixBlendMode: 'overlay',
        }}
      />
    </>
  );
}

export default AuthBackdrop;
